import React, { useState, useEffect } from "react";
import "./PaymentModal.scss";

//slice actions to make payment
import {
  createTenantPayment,
  createSTK,
  checkSTKStatus,
} from "../../redux/slices/sliceActions";

//imports for user data
import { useSelector, useDispatch } from "react-redux";

//functions for datat fetching
import { getProfile } from "../../redux/slices/sliceActions";

const PaymentModal = ({
  isOpen,
  closeModal,
  defaultValues = {},
  fieldsToShow = [],
}) => {
  const [marginTopSet, setMarginTopSet] = useState("10vh");

  useEffect(() => {
    console.log("defaultValues", defaultValues);
  }, [defaultValues]);

  useEffect(() => {
    if (fieldsToShow.length === 1) {
      setMarginTopSet("20vh");
    }
  }, [fieldsToShow]);

  //user data
  const dispatch = useDispatch();
  const { user, profile } = useSelector((state) => state.landlordslice);
  const token = user?.accessToken;
  const id = user?.data?.user?.user_id;

  console.log("user data in payment modal", user);
  const [paymentDetails, setPaymentDetails] = useState({
    rent: defaultValues?.rent || "",
    water: defaultValues?.water || "",
    arrears: defaultValues?.arrears || "",
    serviceCharge: defaultValues?.serviceCharge || "",
    unpaidDeposit: defaultValues?.unpaidDeposit || "",
    garbage: defaultValues?.garbage || "",
    paymentMethod: defaultValues?.paymentMethod || "TILLNO",
    phoneNumber: defaultValues?.phoneNumber || "",
    referenceNumber: defaultValues?.referenceNumber || "",
    paymentNarration: defaultValues?.paymentNarration || "",
  });

  const [loading, setLoading] = useState(false);
  const [complete, setComplete] = useState(false);

  useEffect(() => {
    setPaymentDetails({
      rent: defaultValues?.rent || "",
      water: defaultValues?.water || "",
      arrears: defaultValues?.arrears || "",
      serviceCharge: defaultValues?.serviceCharge || "",
      unpaidDeposit: defaultValues?.unpaidDeposit || "",
      garbage: defaultValues?.garbage || "",
      paymentMethod: defaultValues?.paymentMethod || "TILLNO",
      phoneNumber: defaultValues?.phoneNumber || "",
      referenceNumber: defaultValues?.referenceNumber || "",
      paymentNarration: defaultValues?.paymentNarration || "",
      month: defaultValues?.month || new Date().getMonth() + 1,
      year: defaultValues?.year || new Date().getFullYear(),
    });
    setLoading(false);
    setComplete(false);
  }, [defaultValues]);

  const [totalAmount, setTotalAmount] = useState(0);

  useEffect(() => {
    const total = fieldsToShow.reduce((sum, field) => {
      return sum + Number(paymentDetails[field] || 0);
    }, 0);
    setTotalAmount(total);
  }, [paymentDetails, fieldsToShow]);

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    const val = type === "number" ? (value ? parseInt(value, 10) : "") : value;
    setPaymentDetails({ ...paymentDetails, [name]: val });
  };

  const currentDate = new Date();
  const currentDay = currentDate.getDate();
  const currentMonth = currentDate.getMonth() + 1; // Months are zero-indexed
  const currentYear = currentDate.getFullYear();

  const [selectedDate, setSelectedDate] = useState(currentDay);
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const [selectedYear, setSelectedYear] = useState(currentYear);

  const handleDateSelect = (e) => {
    const { name, value } = e.target;
    const parsedValue = parseInt(value, 10);

    if (name === "date") {
      setSelectedDate(parsedValue);
    } else if (name === "month") {
      setSelectedMonth(parsedValue);
    } else if (name === "year") {
      setSelectedYear(parsedValue);
    }
  };

  function formatDate(year, month, day) {
    // Pad month and day with leading zeros if they are less than 10
    const formattedMonth = month.toString().padStart(2, "0");
    const formattedDay = day.toString().padStart(2, "0");

    // Return the formatted date as YYYY-MM-DD
    return `${year}-${formattedMonth}-${formattedDay}`;
  }

  const [paymentDate, setPaymentDate] = useState("");

  useEffect(() => {
    const formatedDate = formatDate(selectedYear, selectedMonth, selectedDate);
    setPaymentDate(formatedDate);
  }, [selectedDate, selectedMonth, selectedYear]);

  //submit payment
  const [submissionState, setSubmissionState] = useState("idle"); // 'idle', 'loading', 'complete', 'failed'
  const [failureMessage, setFailureMessage] = useState(
    "Payment was not completed. Please try again or contact support."
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmissionState("loading");
    let newPaymentDetails;
    if (!fieldsToShow) {
      newPaymentDetails = {
        houseId: user?.data?.house?.house_id,
        houseNumber: user?.data?.house?.house_number,
        paymentMethod: paymentDetails.paymentMethod || "CASH",
        paymentReference: paymentDetails.paymentReference || "",
        paymentNarration: paymentDetails.paymentNarration || "",
        payerTransactionReference: paymentDetails.referenceNumber || "",
        paymentDate: paymentDate,
        month: defaultValues?.month || new Date().getMonth() + 1,
        year: defaultValues?.year || new Date().getFullYear(),
        rentAmount: paymentDetails.rent || 0,
        waterAmount: paymentDetails.water || 0,
        garbageAmount: paymentDetails.garbage || 0,
        serviceFeeAmount: paymentDetails.serviceCharge || 0,
        lateFeeAmount: paymentDetails.lateFee || 0,
        arrearsAmount: paymentDetails.arrears || 0,
        unpaidDepositAmount: paymentDetails.unpaidDeposit || 0,
      };
    } else {
      switch (fieldsToShow[0]) {
        case "rent":
          newPaymentDetails = {
            houseId: user?.data?.house?.house_id,
            houseNumber: user?.data?.house?.house_number,
            paymentMethod: paymentDetails.paymentMethod || "CASH",
            paymentReference: paymentDetails.paymentReference || "",
            paymentNarration: paymentDetails.paymentNarration || "",
            payerTransactionReference: paymentDetails.referenceNumber || "",
            paymentDate: paymentDate,
            month: defaultValues?.month || new Date().getMonth() + 1,
            year: defaultValues?.year || new Date().getFullYear(),
            rentAmount: paymentDetails.rent || 0,
            waterAmount: 0,
            garbageAmount: 0,
            serviceFeeAmount: 0,
            lateFeeAmount: 0,
            arrearsAmount: 0,
            unpaidDepositAmount: 0,
          };
          break;
        case "water":
          newPaymentDetails = {
            houseId: user?.data?.house?.house_id,
            houseNumber: user?.data?.house?.house_number,
            paymentMethod: paymentDetails.paymentMethod || "CASH",
            paymentReference: paymentDetails.paymentReference || "",
            paymentNarration: paymentDetails.paymentNarration || "",
            payerTransactionReference: paymentDetails.referenceNumber || "",
            paymentDate: paymentDate,
            month: defaultValues?.month || new Date().getMonth() + 1,
            year: defaultValues?.year || new Date().getFullYear(),
            rentAmount: 0,
            waterAmount: paymentDetails.water || 0,
            garbageAmount: 0,
            serviceFeeAmount: 0,
            lateFeeAmount: 0,
            arrearsAmount: 0,
            unpaidDepositAmount: 0,
          };
          break;
        case "garbage":
          newPaymentDetails = {
            houseId: user?.data?.house?.house_id,
            houseNumber: user?.data?.house?.house_number,
            paymentMethod: paymentDetails.paymentMethod || "CASH",
            paymentReference: paymentDetails.paymentReference || "",
            paymentNarration: paymentDetails.paymentNarration || "",
            payerTransactionReference: paymentDetails.referenceNumber || "",
            paymentDate: paymentDate,
            month: defaultValues?.month || new Date().getMonth() + 1,
            year: defaultValues?.year || new Date().getFullYear(),
            rentAmount: 0,
            waterAmount: 0,
            garbageAmount: paymentDetails.garbage || 0,
            serviceFeeAmount: 0,
            lateFeeAmount: 0,
            arrearsAmount: 0,
            unpaidDepositAmount: 0,
          };
          break;
        case "serviceCharge":
          newPaymentDetails = {
            houseId: user?.data?.house?.house_id,
            houseNumber: user?.data?.house?.house_number,
            paymentMethod: paymentDetails.paymentMethod || "CASH",
            paymentReference: paymentDetails.paymentReference || "",
            paymentNarration: paymentDetails.paymentNarration || "",
            payerTransactionReference: paymentDetails.referenceNumber || "",
            paymentDate: paymentDate,
            month: defaultValues?.month || new Date().getMonth() + 1,
            year: defaultValues?.year || new Date().getFullYear(),
            rentAmount: 0,
            waterAmount: 0,
            garbageAmount: 0,
            serviceFeeAmount: paymentDetails.serviceCharge || 0,
            lateFeeAmount: 0,
            arrearsAmount: 0,
            unpaidDepositAmount: 0,
          };
          break;
        case "arrears":
          newPaymentDetails = {
            houseId: user?.data?.house?.house_id,
            houseNumber: user?.data?.house?.house_number,
            paymentMethod: paymentDetails.paymentMethod || "CASH",
            paymentReference: paymentDetails.paymentReference || "",
            paymentNarration: paymentDetails.paymentNarration || "",
            payerTransactionReference: paymentDetails.referenceNumber || "",
            paymentDate: paymentDate,
            month: defaultValues?.month || new Date().getMonth() + 1,
            year: defaultValues?.year || new Date().getFullYear(),
            rentAmount: 0,
            waterAmount: 0,
            garbageAmount: 0,
            serviceFeeAmount: 0,
            lateFeeAmount: 0,
            arrearsAmount: paymentDetails.arrears || 0,
            unpaidDepositAmount: 0,
          };
          break;
        case "unpaidDeposit":
          newPaymentDetails = {
            houseId: user?.data?.house?.house_id,
            houseNumber: user?.data?.house?.house_number,
            paymentMethod: paymentDetails.paymentMethod || "CASH",
            paymentReference: paymentDetails.paymentReference || "",
            paymentNarration: paymentDetails.paymentNarration || "",
            payerTransactionReference: paymentDetails.referenceNumber || "",
            paymentDate: paymentDate,
            month: defaultValues?.month || new Date().getMonth() + 1,
            year: defaultValues?.year || new Date().getFullYear(),
            rentAmount: 0,
            waterAmount: 0,
            garbageAmount: 0,
            serviceFeeAmount: 0,
            lateFeeAmount: 0,
            arrearsAmount: 0,
            unpaidDepositAmount: paymentDetails.unpaidDeposit || 0,
          };
          break;
      }
    }

    try {
      // if (newPaymentDetails?.paymentMethod === "TILLNO") {
      console.log("payment method is STK_PUSH");
      const stkResponse = await dispatch(
        createSTK({
          paymentDetails: {
            house_id: newPaymentDetails?.houseId,
            narration: newPaymentDetails?.paymentNarration,
            month: newPaymentDetails?.month,
            year: newPaymentDetails?.year,
            rent: newPaymentDetails?.rentAmount,
            water: newPaymentDetails?.waterAmount,
            garbage: newPaymentDetails?.garbageAmount,
            service_charge: newPaymentDetails?.serviceFeeAmount,
            late_fee: newPaymentDetails?.lateFeeAmount,
            arrears: newPaymentDetails?.arrearsAmount,
            unpaid_deposit: newPaymentDetails?.unpaidDepositAmount,
            phone: paymentDetails?.phoneNumber,
          },
        })
      );

      console.log("STK Response", stkResponse);

      // Extract checkout request ID and start polling
      const checkoutRequestId = stkResponse?.payload?.data?.checkoutRequestId;

      if (checkoutRequestId) {
        console.log(
          "Starting polling for checkout request:",
          checkoutRequestId
        );

        // Start polling for payment status
        const pollInterval = setInterval(async () => {
          try {
            const response = await dispatch(
              checkSTKStatus({ checkoutRequestId })
            );
            console.log("Polling response:", response);

            const responseData = response?.payload?.data;
            const isCompleted = responseData?.isCompleted;
            const isFailed = responseData?.isFailed;
            const isExpired = responseData?.isExpired;
            const shouldStopPolling = responseData?.shouldStopPolling;
            const payment = responseData?.payment;
            const failureReason = responseData?.failureReason;

            // Stop polling if the API indicates we should stop
            if (shouldStopPolling === true) {
              clearInterval(pollInterval);

              if (isCompleted === true && payment) {
                // Payment successful
                console.log("Payment successful!", payment);
                setSubmissionState("complete");

                // Refresh profile
                dispatch(getProfile({ userId: id })).then((res) => {
                  console.log("Profile updated after successful payment", res);
                });

                // Close modal after showing success
                setTimeout(() => {
                  closeModal();
                  setSubmissionState("idle");
                }, 3000);
              } else if (isFailed === true || isExpired === true) {
                // Payment failed, expired, or was cancelled
                console.log(
                  "Payment failed:",
                  failureReason || "Payment was not completed"
                );
                setFailureMessage(
                  failureReason ||
                    "Payment was not completed. Please try again or contact support."
                );
                setSubmissionState("failed");
              } else {
                // Other failure scenarios
                console.log("Payment failed or cancelled");
                setFailureMessage(
                  "Payment was not completed. Please try again or contact support."
                );
                setSubmissionState("failed");
              }
            }
            // If shouldStopPolling is false, continue polling (payment still pending)
          } catch (error) {
            console.error("Polling error:", error);
            clearInterval(pollInterval);
            setSubmissionState("failed");
          }
        }, 5000); // Poll every 5 seconds

        // Set a timeout to stop polling after 5 minutes
        setTimeout(() => {
          clearInterval(pollInterval);
          if (submissionState === "loading") {
            console.log("Polling timeout - payment took too long");
            setSubmissionState("failed");
          }
        }, 300000); // 5 minutes timeout
      } else {
        console.error("No checkout request ID received from STK response");
        setSubmissionState("failed");
      }

      //  else {
      //   // Handle other payment methods - fallback to the original method
      //   await dispatch(
      //     createTenantPayment({
      //       details: newPaymentDetails,
      //     })
      //   ).then((res) => {
      //     console.log("Payment response", res);
      //     dispatch(getProfile({ userId: id })).then((res) => {
      //       console.log("New Profile Response", res);
      //     });
      //   });

      //   setSubmissionState("complete");
      //   setTimeout(() => {
      //     closeModal();
      //     setSubmissionState("idle");
      //   }, 2000);
      // }
    } catch (error) {
      console.error("Payment submission failed", error);
      setSubmissionState("failed");
      setTimeout(() => {
        setSubmissionState("idle");
      }, 5000);
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div
        className="modal-content"
        style={{ marginTop: `${marginTopSet}` }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="pay-window-title">Make a Payment</div>

        {submissionState === "loading" ? (
          <div className="loading-container">
            <div className="loader"></div>
            {paymentDetails.paymentMethod === "TILLNO" && (
              <div
                style={{
                  textAlign: "center",
                  marginTop: "20px",
                  fontSize: "14px",
                  color: "#666",
                }}
              >
                Please complete the payment on your phone. Waiting for
                confirmation...
              </div>
            )}
          </div>
        ) : submissionState === "complete" ? (
          <div className="complete-container">
            <div
              className="complete-animation"
              style={{ color: "#28a745", fontSize: "18px", fontWeight: "bold" }}
            >
              Payment Successful!
            </div>
            <div
              style={{
                textAlign: "center",
                color: "#28a745",
                marginTop: "10px",
                fontSize: "14px",
              }}
            >
              Your payment has been processed successfully.
            </div>
          </div>
        ) : submissionState === "failed" ? (
          <div
            className="failed-container"
            style={{ textAlign: "center", padding: "20px" }}
          >
            <div
              style={{
                color: "#dc3545",
                fontSize: "18px",
                fontWeight: "bold",
                marginBottom: "10px",
              }}
            >
              Payment Failed
            </div>
            <div
              style={{
                color: "#dc3545",
                fontSize: "14px",
                marginBottom: "20px",
              }}
            >
              {failureMessage}
            </div>
            <div style={{ display: "flex" }}>
              <button
                type="button"
                className="submit-btn"
                onClick={() => setSubmissionState("idle")}
                style={{ marginRight: "10px" }}
              >
                Try Again
              </button>
              <button type="button" className="close-btn" onClick={closeModal}>
                Close
              </button>
            </div>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            {/* Payment Method Selection */}
            <div style={{ display: "flex", gap: "10px" }}>
              <div className="form-group">
                <label htmlFor="paymentMethod">Payment Method:</label>
                <select
                  id="paymentMethod"
                  name="paymentMethod"
                  value={paymentDetails.paymentMethod}
                        onChange={handleChange}
                        
                >
                  <option value="TILLNO">Lipa Na Mpesa STK</option>
                  <option value="PAYBILL">Paybill</option>
                  {/* <option value="PAYBILL">M-Pesa</option>
                  <option value="BANK_TRANSFER">Bank Transfer</option>
                  <option value="CASH">Cash</option> */}
                </select>
              </div>

              {/* Conditionally render fields based on payment method */}
              {paymentDetails.paymentMethod === "TILLNO" && (
              <div className="form-group">
                <label htmlFor="phoneNumber">Phone Number:</label>
                <input
                  type="text"
                  id="phoneNumber"
                  name="phoneNumber"
                  value={paymentDetails.phoneNumber}
                  onChange={handleChange}
                  required
                />
              </div>
              )}

              {/* {["PAYBILL", "BANK_TRANSFER", "M-Pesa"].includes(
                paymentDetails.paymentMethod
              ) && (
                <div className="form-group">
                  <label htmlFor="referenceNumber">Reference Number:</label>
                  <input
                    type="text"
                    id="referenceNumber"
                    name="referenceNumber"
                    value={paymentDetails.referenceNumber}
                    onChange={handleChange}
                    required
                  />
                </div>
              )} */}
            </div>

            {/* Paybill Instructions */}
            {paymentDetails.paymentMethod === "PAYBILL" && (
              <div className="paybill-instructions">
                <h3>How to Pay via Paybill</h3>
                <div className="instruction-content">
                  <p>On a Safaricom line, follow these steps:</p>
                  <ol>
                    <li>Go to <strong>M-PESA</strong> menu</li>
                    <li>Select <strong>Lipa na M-PESA</strong></li>
                    <li>Select <strong>Paybill</strong></li>
                    <li>Enter Business Number: <span className="highlight-number">4097597</span></li>
                    <li>Enter Account Number: <span className="highlight-number">{`${user?.data?.house?.property_account_number }#${user?.data?.house?.house_number || 'YOUR_HOUSE_NUMBER'}`}</span></li>
                    <li>Enter the amount: <span className="highlight-amount">KSh {totalAmount}</span></li>
                    <li>Enter your M-PESA PIN and confirm</li>
                  </ol>
                  <div className="important-note">
                    <strong>Important:</strong> Make sure to include your house number at the end of the account number.
                  </div>
                </div>
              </div>
            )}

            {paymentDetails.paymentMethod !== "PAYBILL" && (
              <>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "5px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "5px",
                  width: "100%",
                }}
              >
                <div className="form-group">
                  <label htmlFor="date">Day</label>
                  <select
                    id="date"
                    name="date"
                    value={selectedDate}
                    onChange={handleDateSelect}
                    required
                  >
                    {[...Array(31).keys()].map((day) => (
                      <option key={day + 1} value={day + 1}>
                        {day + 1}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="month">Month</label>
                  <select
                    id="month"
                    name="month"
                    value={selectedMonth}
                    onChange={handleDateSelect}
                    required
                  >
                    {[
                      "January",
                      "February",
                      "March",
                      "April",
                      "May",
                      "June",
                      "July",
                      "August",
                      "September",
                      "October",
                      "November",
                      "December",
                    ].map((month, index) => (
                      <option key={index + 1} value={index + 1}>
                        {month}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="year">Year</label>
                  <select
                    id="year"
                    name="year"
                    value={selectedYear}
                    onChange={handleDateSelect}
                    required
                  >
                    {Array.from({ length: 11 }, (_, i) => 2020 + i).map(
                      (year) => (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      )
                    )}
                  </select>
                </div>
              </div>
            </div>

            {/* Payment Narration Field */}
            <div className="form-group">
              <label htmlFor="paymentNarration">Payment Narration:</label>
              <input
                type="text"
                id="paymentNarration"
                name="paymentNarration"
                value={paymentDetails.paymentNarration}
                onChange={handleChange}
              />
            </div>

            {/* Dynamically render fields based on fieldsToShow prop */}

            <div style={{ display: "flex", gap: "10px" }}>
              {fieldsToShow.includes("rent") && (
                <div className="form-group">
                  <label htmlFor="rent">Rent:</label>
                  <input
                    type="number"
                    id="rent"
                    name="rent"
                    value={paymentDetails.rent}
                    onChange={handleChange}
                    required
                  />
                </div>
              )}

              {fieldsToShow.includes("water") && (
                <div className="form-group">
                  <label htmlFor="water">Water:</label>
                  <input
                    type="number"
                    id="water"
                    name="water"
                    value={paymentDetails.water}
                    onChange={handleChange}
                    required
                  />
                </div>
              )}
            </div>

            <div style={{ display: "flex", gap: "10px" }}>
              {fieldsToShow.includes("arrears") && (
                <div className="form-group">
                  <label htmlFor="arrears">Arrears:</label>
                  <input
                    type="number"
                    id="arrears"
                    name="arrears"
                    value={paymentDetails.arrears}
                    onChange={handleChange}
                    required
                  />
                </div>
              )}

              {fieldsToShow.includes("serviceCharge") && (
                <div className="form-group">
                  <label htmlFor="serviceCharge">Service Charge:</label>
                  <input
                    type="number"
                    id="serviceCharge"
                    name="serviceCharge"
                    value={paymentDetails.serviceCharge}
                    onChange={handleChange}
                    required
                  />
                </div>
              )}
            </div>

            <div style={{ display: "flex", gap: "10px" }}>
              {fieldsToShow.includes("unpaidDeposit") && (
                <div className="form-group">
                  <label htmlFor="unpaidDeposit">Unpaid Deposit:</label>
                  <input
                    type="number"
                    id="unpaidDeposit"
                    name="unpaidDeposit"
                    value={paymentDetails.unpaidDeposit}
                    onChange={handleChange}
                    required
                  />
                </div>
              )}

              {fieldsToShow.includes("garbage") && (
                <div className="form-group">
                  <label htmlFor="garbage">Garbage:</label>
                  <input
                    type="number"
                    id="garbage"
                    name="garbage"
                    value={paymentDetails.garbage}
                    onChange={handleChange}
                    required
                  />
                </div>
              )}
            </div>

            {/* display total ammount */}
            <div
              className="form-group"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <div style={{ fontSize: "20px" }}>
                Total Amount: ksh {totalAmount}
              </div>
            </div>
              </>
            )}

            <div style={{ display: "flex", justifyContent: "center" }}>
              {paymentDetails.paymentMethod !== "PAYBILL" && (
              <button type="submit" className="submit-btn">
                Submit Payment
              </button>
              )}
              <button type="button" className="close-btn" onClick={closeModal}>
                Close
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default PaymentModal;
